import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

// eslint-disable-next-line import-x/extensions
import enTranslation from "./assets/translations/en.json";
// eslint-disable-next-line import-x/extensions
import esTranslation from "./assets/translations/es.json";

const initI18n = async () => {
  try {
    await i18n
      .use(LanguageDetector)
      .use(initReactI18next)
      .init({
        resources: {
          es: {
            translation: esTranslation,
          },
          en: {
            translation: enTranslation,
          },
        },
        // In tests, bypass LanguageDetector: navigator.language is
        // non-deterministic in jsdom and module-level t() calls run before
        // beforeAll hooks, so language must be fixed at init time.
        ...(import.meta.env.MODE === "test" ? { lng: "es" } : {}),
        detection: {
          order: ["navigator"],
        },
        fallbackLng: "en",
        supportedLngs: ["es", "en"],
        load: "languageOnly",
        nonExplicitSupportedLngs: true,
        interpolation: {
          escapeValue: false,
        },
      });
  } catch (error) {
    // Initialization errors are critical
    if (import.meta.env.DEV) {
      throw error; // Let dev tools catch it
    }
    // Fail silently in production
  }
};

void initI18n();

export { i18n };
